<template>
    <div>
        <v-dialog v-model="instanciasDialog" max-width="1024" scrollable>
            <v-card>
                <v-card-title>
                    <v-icon left>mdi-whatsapp</v-icon>Instâncias disponíveis
                    <v-spacer></v-spacer>
                    <v-btn icon @click="instanciasDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-data-table :headers="zcinstancias_headers" :items="zcinstancias" class="elevation-1"
                        :loading="loading" disable-pagination hide-default-footer>
                        <template v-slot:[`item.clienteId`]="{ item }">
                            <v-icon color="green" v-if="item.clienteId > 0" title="Sim">mdi-check-circle </v-icon>
                            <v-icon color="red" v-if="item.clienteId === null" title="Não">mdi-cancel</v-icon>
                        </template>

                        <template v-slot:[`item.zci_assinado`]="{ item }">
                            <v-icon color="green" v-if="item.zci_assinado == true" title="Sim">mdi-check-circle</v-icon>
                            <v-icon color="red" v-if="item.zci_assinado == false" title="Não">mdi-cancel</v-icon>
                        </template>

                        <template v-slot:[`item.vincular`]="{ item }">
                            <v-checkbox v-model="item.vincular" @click="addVinculo(item)"
                                v-if="!item.loading"></v-checkbox>
                            <v-progress-circular indeterminate v-if="item.loading"
                                :color="item.vincular ? 'primary' : 'grey'" :size="26"
                                class="mt-5 mb-5"></v-progress-circular>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn class="white--text" color="primary" elevation="1" @click="novoVinculo()">
                    <v-icon left> mdi-plus </v-icon>
                    Vincular instância
                </v-btn>
            </v-card-title>
            <v-data-table :headers="headers" :items="instancias" disable-pagination hide-default-footer>
                <template v-if="(userSiczap || userMaster)" v-slot:[`item.acao`]="{ item }">
                    <v-btn title="Desvincular" icon @click="desvincularInstancia(item.id)">
                        <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                </template>

                <template v-slot:[`item.zci_assinado`]="{ item }">
                    <v-icon color="green" v-if="item.zci_assinado == true" title="Sim">mdi-check-circle</v-icon>
                    <v-icon color="red" v-if="item.zci_assinado == false" title="Não">mdi-cancel</v-icon>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        clienteId: String,
        instancias: Array
    },
    data: () => ({
        headers: [
            { text: 'Descrição', value: 'zci_nome' },
            { text: 'Sessão', value: 'zci_nomesessao' },
            { text: 'Id Instância', value: 'zci_idinstancia' },
            { text: 'Token Instância', value: 'zci_tokeninstancia' },
            { text: 'Instância assinada?', value: 'zci_assinado' },
            { text: 'Ações', value: 'acao', align: 'right' }
        ],
        zcinstancias_headers: [
            { text: 'Descrição', value: 'zci_nome' },
            { text: 'Sessão', value: 'zci_nomesessao' },
            { text: 'Id Instância', value: 'zci_idinstancia' },
            { text: 'Token Instância', value: 'zci_tokeninstancia' },
            { text: 'Instância assinada?', value: 'zci_assinado' },
            { text: 'Vincular?', value: 'vincular', align: 'right' }
        ],
        loading: false,
        zcinstancias: [],
        instanciasDialog: false,
    }),
    computed: {
        ...mapGetters(['userSiczap', 'userMaster']),
    },
    methods: {
        async novoVinculo() {
            try {
                this.instanciasDialog = true
                this.loading = true
                const response = await this.axios.get(`/siczap/instancias/disponivel`)
                this.zcinstancias = response.data.instancias
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.loading = false
            }
        },
        async addVinculo(item) {
            try {

                this.loading = true
                this.$set(item, 'loading', true);
                var request = {
                    instanciaId: item.id,
                    clienteId: this.clienteId
                }
                await new Promise(resolve => setTimeout(resolve, 1000));
                await this.axios.post(`/siczap/instancia/vincular`, request)
                this.$store.dispatch('showSuccess', 'Instância vinculada com sucesso!')
                this.novoVinculo()
                this.$emit('instanciasChanged')
                this.loading = false;
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.loading = false
                this.$set(item, 'loading', false);
            }
        },
        async loadInstanciasZap() {
            try {
                this.loading = true;
                const response = await this.axios.get(`/siczap/instancias/cliente/id/${this.clienteId}`)
                this.instancias = response.data.instancias
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
            finally {
                this.loading = false
            }
        },
        async desvincularInstancia(instanciaId) {
            try {
                this.loading = true

                var request = {
                    instanciaId: instanciaId,
                    clienteId: this.clienteId
                }
                await this.axios.post(`/siczap/instancia/desvincular`, request)
                this.$store.dispatch('showSuccess', 'Instância desvinculada com sucesso!')
                this.$emit('instanciasChanged')
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.loading = false
            }
        }
    },
    watch: {

    }
}
</script>